import React from "react";
import './Course.css';

import { Link } from "react-router-dom";

import { FaUser } from "react-icons/fa";
import { FaCalendarDays } from "react-icons/fa6";



const Course = ({ course }) => {

    return (

        <div className="course-item">

            <div className="image">
                <img src={course.image} alt={course.title} /> {/* Course Image */}
                <div className="fee">{course.details.price}</div> {/* Course Fee */}
            </div>

            <div className="content">

                {/* Course details section */}
                <div className='details'>

                    {/* Course Duration */}
                    <h3>
                        <div className='icon'><FaCalendarDays /></div>
                        <span>{course.details.duration}</span>
                    </h3>

                    {/* Course Instructor */}
                    <h3>
                        <div className='icon'><FaUser /></div>
                        <span>{course.details.instructor}</span>
                    </h3>

                </div>

                <div className="text">

                    {/* Link to the individual Course page */}
                    <Link
                        to={{
                            pathname: '/Courses/' + course.title,  // Navigate to the specific Course page
                        }}
                        location = {{course}}  // Passing Course details to the linked page
                        className="main-heading"
                        state= {course}> 
                        {course.title} {/* Course Title */}
                    </Link>

                    <p>{course.content}</p> {/* Course Description */}

                </div>

            </div>

        </div>
    );
};

export default Course;